import React from 'react';

export default function MetricCard({ label, value, color = 'blue' }) {
  const colorClasses = {
    blue: 'bg-blue-50 text-blue-700 border-blue-200',
    green: 'bg-green-50 text-green-700 border-green-200',
    orange: 'bg-orange-50 text-orange-700 border-orange-200',
    purple: 'bg-purple-50 text-purple-700 border-purple-200',
    red: 'bg-red-50 text-red-700 border-red-200',
    gray: 'bg-gray-50 text-gray-700 border-gray-200'
  };

  return (
    <div className="flex flex-col">
      <div className="text-xs font-medium text-gray-600 mb-2 uppercase tracking-wide text-center">
        {label}
      </div>
      <div className={`text-2xl font-bold ${colorClasses[color]} border rounded-lg px-3 py-3 text-center transition-all hover:shadow-md`}>
        {value}
      </div>
    </div>
  );
}